// extracted by mini-css-extract-plugin
export var bgColorOverflow = "HeroLayout-module--bgColorOverflow--e99c1";
export var bgImage = "HeroLayout-module--bgImage--56ca4";
export var date = "HeroLayout-module--date--00790";
export var footerBG = "HeroLayout-module--footerBG--9bb58";
export var fullSizeBg = "HeroLayout-module--fullSizeBg--66000";
export var info = "HeroLayout-module--info--d7909";
export var root = "HeroLayout-module--root--b2a28";
export var subheader = "HeroLayout-module--subheader--2e7f0";
export var title = "HeroLayout-module--title--71c3b";
export var translations = "HeroLayout-module--translations--a8052";
export var whiteBg = "HeroLayout-module--whiteBg--d9479";